import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({className='', dimension=20}: Props) => (
  <svg width={dimension} height={dimension} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <mask id="mask0_16191_40304" maskUnits="userSpaceOnUse" x="0" y="0" width={dimension} height={dimension}>
      <rect width={dimension} height={dimension} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16191_40304)">
      <path
        d="M5.00065 18.3334C4.54232 18.3334 4.14996 18.1702 3.82357 17.8438C3.49718 17.5174 3.33398 17.125 3.33398 16.6667V8.33337C3.33398 7.87504 3.49718 7.48268 3.82357 7.15629C4.14996 6.8299 4.54232 6.66671 5.00065 6.66671H5.83398V5.00004C5.83398 3.84726 6.24023 2.86462 7.05273 2.05212C7.86523 1.23962 8.84787 0.833374 10.0007 0.833374C11.1534 0.833374 12.1361 1.23962 12.9486 2.05212C13.7611 2.86462 14.1673 3.84726 14.1673 5.00004V6.66671H15.0007C15.459 6.66671 15.8513 6.8299 16.1777 7.15629C16.5041 7.48268 16.6673 7.87504 16.6673 8.33337V16.6667C16.6673 17.125 16.5041 17.5174 16.1777 17.8438C15.8513 18.1702 15.459 18.3334 15.0007 18.3334H5.00065ZM10.0007 14.1667C10.459 14.1667 10.8513 14.0035 11.1777 13.6771C11.5041 13.3507 11.6673 12.9584 11.6673 12.5C11.6673 12.0417 11.5041 11.6493 11.1777 11.323C10.8513 10.9966 10.459 10.8334 10.0007 10.8334C9.54232 10.8334 9.14996 10.9966 8.82357 11.323C8.49718 11.6493 8.33398 12.0417 8.33398 12.5C8.33398 12.9584 8.49718 13.3507 8.82357 13.6771C9.14996 14.0035 9.54232 14.1667 10.0007 14.1667ZM7.50065 6.66671H12.5007V5.00004C12.5007 4.3056 12.2576 3.71532 11.7715 3.22921C11.2854 2.7431 10.6951 2.50004 10.0007 2.50004C9.30621 2.50004 8.71593 2.7431 8.22982 3.22921C7.74371 3.71532 7.50065 4.3056 7.50065 5.00004V6.66671Z"
        fill="#01916D"
      />
    </g>
  </svg>
);

export default Icon;
